/**
 * Mauritian rupee.
 */
export var MUR = {
  code: 'MUR',
  base: 10,
  exponent: 2
};